export default "__VITE_ASSET__5130c70b__"